import { NewOrderModalNew } from "./NewOrderModalNew";

export default NewOrderModalNew;
